module.exports = __webpack_public_path__ + "img/2-md.b811abb0.jpg";